import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/InsightsPage";
import { router } from "@/router";
import { getGlobal } from "@/functions/getGlobal";
import { stripTags } from "@/functions/stripTags";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["blog"];

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global["page.insights.banner.title.en"]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "InsightsPageBannerSection", props: { className: "pb-5" } },
        { component: "InsightsPageFeedSection", props: { className: "pb-4 pb-md-5 mb-md-5" } },
      ],
    },
  };
}
